import {
  initColor,
  initComponent,
  initPlugin,
  initProperty,
} from './init'
import {
  initAppPlugin
} from '@/init'

export default {
  install: (app) => {
    initColor(app)
    initComponent(app)
    initPlugin(app)
    initProperty(app)
    initAppPlugin(app)
  },
}